import fundDetails from './index';
import Balance from './components/Balance.vue';
import Contract from './components/Contract.vue';
import Current from './components/Current.vue';
import Pledge from './components/Pledge.vue';
import TradeFee from './components/TradeFee.vue';
import TribeProfit from './components/TribeProfit.vue';
import User from './components/User.vue';
import WalletBill from './components/WalletBill.vue';
import DepositWithdrawVisual from './components/DWVisual';
import StakingData from './components/StakingData.vue';
import TradeVolume from './components/TradeVolume.vue';
import ListingApply from './components/ListingApply.vue';
import DwSummary from './components/DwSummary.vue';
import RechangeReturn from './components/RechangeReturn.vue';

export default {
    path: '/fundDetails',
    component: fundDetails,
    children: [
        {
            path: '/fundDetails/balance',
            component: Balance
        },
        {
            path: '/fundDetails/contract',
            component: Contract
        },
        {
            path: '/fundDetails/current',
            component: Current
        },
        {
            path: '/fundDetails/pledge',
            component: Pledge
        },
        {
            path: '/fundDetails/tradefee',
            component: TradeFee
        },
        {
            path: '/fundDetails/tribeprofit',
            component: TribeProfit
        },
        {
            path: '/fundDetails/tradeVoulmeData',
            component: TradeVolume
        },
        {
            path: '/fundDetails/stakingData',
            component: StakingData
        },
        {
            path: '/fundDetails/listingApply',
            component: ListingApply
        },
        {
            path: '/fundDetails/user',
            component: User
        },
        {
            path: '/fundDetails/walletbill',
            component: WalletBill
        },
        {
            path: '/fundDetails/dw/visual',
            component: DepositWithdrawVisual
        },
        {
            path: '/fundDetails/dwsummary',
            component: DwSummary
        },
        {
            path: '/fundDetails/rechangeReturn',
            component: RechangeReturn
        }
    ]
};
